import React from 'react';

interface ThreadSeparatorProps {
  replyCount: number;
  className?: string;
}

const ThreadSeparator: React.FC<ThreadSeparatorProps> = ({ replyCount, className = '' }) => {
  if (replyCount <= 0) {
    return null;
  }

  return (
    <div className={`flex items-center gap-3 py-3 ${className}`}>
      <span className='text-sm text-gray-400'>{replyCount}件の返信</span>
      <div className='flex-1 border-t border-gray-200' />
    </div>
  );
};

export default ThreadSeparator;
